module.exports = __webpack_public_path__ + "img/titleen.df8480af.png";